package dev.lingvo.shared.screenshots.templates

import dev.lingvo.shared.screenshots.doc.BrandKit

/**
 * Sample content for Tally, a fictional subscription tracker, keeps first-run previews useful before capture.
 * These seven transcreations are sample copy requiring native-language review, never approved customer strings.
 * The deliberately long German compound stresses fitting; Arabic includes an explicit two-line example.
 */
object SampleApp {
    /** A neutral green brand avoids trademarks and provides a reproducible example hue. */
    val brand: BrandKit = BrandKit("Tally", primary = "#24745B")
    /** Benefits lead the set; settings is intentionally last rather than the first screenshot. */
    val slots: List<TemplateSlot> = listOf("home", "add", "renewals", "insights", "settings").map { TemplateSlot(it, null) }
    /** Script variety exercises long words, RTL, CJK and Devanagari in the same compositions. */
    val locales: List<String> = listOf("en", "de", "pt-BR", "ja", "ar", "hi", "zh-Hans")
    /** Keys match plan slots so caption lookup needs no positional convention outside TemplateSlot. */
    val captions: Map<String, Map<String, String>> = mapOf(
        "en" to words("See every subscription", "Track a new subscription", "Know what renews next", "See where money goes", "Keep reminders on time"),
        "de" to words("Alle Abos im Blick", "Neue Abos festhalten", "Abonnementverlängerungen im Blick", "Ausgaben im Blick", "Rechtzeitig erinnert"),
        "pt-BR" to words("Veja todas as assinaturas", "Adicione uma assinatura", "Saiba o que renova", "Veja para onde vai seu dinheiro", "Receba lembretes na hora"),
        "ja" to words("サブスクをひと目で", "新しい契約を記録", "次の更新日を確認", "支出の流れを見る", "通知の時間を選ぶ"),
        "ar" to words("كل اشتراكاتك\nفي مكان واحد", "أضف اشتراكًا جديدًا", "اعرف موعد التجديد", "تتبّع أين تذهب أموالك", "تذكير في الوقت المناسب"),
        "hi" to words("हर सदस्यता एक नज़र में", "नई सदस्यता जोड़ें", "अगला नवीनीकरण जानें", "जानें पैसा कहाँ जाता है", "सही समय पर याद दिलाएँ"),
        "zh-Hans" to words("所有订阅一目了然", "记录新的订阅", "查看下次续订日期", "看清每一笔支出", "按时收到提醒"),
    )

    /** Fails explicitly on an unknown example cell instead of silently substituting another language. */
    fun caption(locale: String, slotKey: String): String = requireNotNull(captions[locale]?.get(slotKey)) { "Unknown Tally caption: $locale/$slotKey" }

    private fun words(vararg values: String): Map<String, String> = slots.map { it.slotKey }.zip(values).toMap()
}
